import { FC } from "react";
import Hero from "./blocks/hero";
import Offers from "./blocks/offers";
import Advantages from "./blocks/advantages";
import News from "./blocks/news";
import Answers from "./blocks/answers";

const Home: FC = () => {
    return (
        <>
            <div className="container">
                <Hero />
                <Offers />
            </div>
            <Advantages />
            <News />
            <div className="container">
                <Answers />
            </div>
        </>
    );
};

export default Home;
